import { render, staticRenderFns } from "./CpvSubscribed.vue?vue&type=template&id=f8206396&scoped=true&"
import script from "./CpvSubscribed.vue?vue&type=script&lang=js&"
export * from "./CpvSubscribed.vue?vue&type=script&lang=js&"
import style0 from "./CpvSubscribed.vue?vue&type=style&index=0&id=f8206396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8206396",
  null
  
)

export default component.exports